export const peripheralsAccessoriesSupport: Array<string> = [
    "Biometric",
    "Projector",
    "Monitor",
    "Keyboard",
    "Mouse",
    "USB Flash Drive / Removable Media",
    "Printer"
]

export const enterpriceApp: Array<string> = [
    "Internal System Support",
    "Email Support",
    "Oracle Support"
]

export const userAccountManagement: Array<string> = [
    "Create New User Account",
    "User Account Update",
    "User Password Reset",
    "User's Automated Backup"
]

export const desktopSupport: Array<string> = [
    "Hardware",
    "Software Application",
    "Operating System",
    "Web",
    "File/Data",
    "Network"
]

export const laptopSupport: Array<string> = [
    "Hardware",
    "Software Application",
    "Operating System",
    "Web",
    "File/Data",
    "Network"
]

export const mobileSupport: Array<string> = [
    "Hardware",
    "Software Application",
    "Operating System",
    "Files/Data",
    "Network"
]

export const POSSupport: Array<string> = [
    "Hardware",
    "Software",
    "Operating System",
    "Web",
    "Files/Data",
    "POS Database",
    "POS Module",
    "POS Printer",
    "POS Barcode Scanner",
    "POS Weighing Scale",
    "POS Biometric",
    "POS KDS",
    "POS Order Taker",
    "POS Network",
    "POS Receipt",
]